import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'CHARGE_CONFIGS_DETAIL',
        create: 'CHARGE_CONFIGS_CREATE',
        update: 'CHARGE_CONFIGS_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      var L = {
        prop: 'courier_config_l',
        default: '',
        label: 'L',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.courier_config_l,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "courier_config_l", $$v);
              }
            }
          });
        }
      };
      var M = {
        prop: 'courier_config_m',
        default: '',
        label: 'M',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.courier_config_m,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "courier_config_m", $$v);
              }
            }
          });
        }
      };
      var S = {
        prop: 'courier_config_s',
        default: '',
        label: 'S',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.courier_config_s,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "courier_config_s", $$v);
              }
            }
          });
        }
      };
      var XL = {
        prop: 'courier_config_xl',
        default: '',
        label: 'XL',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.courier_config_xl,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "courier_config_xl", $$v);
              }
            }
          });
        }
      };
      var XS = {
        prop: 'courier_config_xs',
        default: '',
        label: 'XS',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.courier_config_xs,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "courier_config_xs", $$v);
              }
            }
          });
        }
      };
      return [
      /* {
        prop: 'market_id',
        default: '',
        label: 'market_id',
        col: { span: 16 },
        render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } custom stringify />
      }, */
      {
        prop: 'market_id',
        default: this.market_id,
        label: this.$t('market_id'),
        col: {
          span: 16
        },
        show: false,
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        // render: () => <d2-dict-select name="form_market_id" vModel={ this.form.model.market_id } clearable custom />
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'charge_name',
        default: '',
        label: this.$t('charge_name'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.charge_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "charge_name", $$v);
              }
            }
          });
        }
      }].concat(_toConsumableArray(1 === 1 ? [L, M, S, XL, XS] : 2 === 3 ? [L, M, S] : []));
    },
    market_id: function market_id() {
      return utils.cookies.get('market_id');
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 洗衣店
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  }
};